import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { keyframes } from '@mui/system';

// 🔁 Infinite horizontal scroll
const scroll = keyframes`
  0% { transform: translateX(100%); }
  100% { transform: translateX(-100%); }
`;

// Pulse animation (for GIF and icons)
const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.85; }
  100% { transform: scale(1); opacity: 1; }
`;

const Message = () => {
  return (
    <Box
      sx={{
        overflow: 'hidden',
        width: '100%',
        backgroundColor: 'white',
        borderBottom: '1px solid #ccc',
      }}
    >
      <Box
        sx={{
          display: 'inline-block',
          whiteSpace: 'nowrap',
          animation: `${scroll} 40s linear infinite`,
          '&:hover': {
            animationPlayState: 'paused', 
          },
        }}
      >
        <Typography
          component="div"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 2,
            px: 4,
            fontWeight: 'bold',
            color: 'blue',
            fontSize: 16,
          }}
        >
          {/* Animated NEW GIF */}
          <Box
            component="img"
            src="https://npsypr-website.blr1.cdn.digitaloceanspaces.com/static-assets/videos/home.gif"
            alt="New"
            sx={{
              width: 40,
              height: 40,
              verticalAlign: 'middle',
              animation: `${pulse} 2s infinite`,
            }}
          />
            {/* <Link href="/admission-criteria" underline="hover" color="inherit">
              Registration for admission to Montessori, Kindergarten, Classes 1- 9 and 11 for the academic year 2026 - 27  is open.
            </Link>
            
          || */}

          <Link href="#" underline="hover" color="inherit">
            Class 11 ( Science , Science Integrated, Commerce and Humanities)
          </Link>

          ||

          <Link href="#activities" underline="hover" color="inherit">
            HIGHLIGHTS OF 2025
          </Link>

          ||

          <Link
            href="https://www.facebook.com/p/National-Public-School-Yeshwanthpur-100084410342747/"
            target="_blank"
            rel="noopener"
            sx={{ color: '#1877F2' }}
          >
            <FacebookIcon sx={{ animation: `${pulse} 2s infinite` }} />
          </Link>
          <Link
            href="https://www.instagram.com/nps_ypr/"
            target="_blank"
            rel="noopener"
            sx={{ color: '#E4405F' }}
          >
            <InstagramIcon sx={{ animation: `${pulse} 2s infinite` }} />
          </Link>

          ||

          <Link href="/careers" underline="hover" color="inherit">
            Careers
          </Link>
         
        </Typography>
      </Box>
    </Box>
  );
};

export default Message;


